import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadFlags } from './../../../../ng2/store/actions/flag-actions';
import { getFlagEntitiesList, getFlagsLoadedStatus } from './../../../../ng2/store/selectors/flags-selectors';

@Injectable()
export class FlagsResolver {
  resolveFlags$(currentSchool, store): Promise<Observable<any>> {
    const { _id } = currentSchool;
    const payload = { schoolId: _id };
    const destroy$: Subject<boolean> = new Subject<boolean>();

    return new Promise(resolve => {
      store
        .select(getFlagsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new LoadFlags(payload));
          if (loaded) {
            const flags$ = store.select(getFlagEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(flags$);
          }
        });
    });
  }
}
